import Vue from "modules/vue_twemoji";
import VueI18n from "vue-i18n";
import DatabaseDocumentation from "components/database-documentation";

Vue.use(VueI18n);

const $container = document.querySelector(".js-db-documentation");

if($container) {
  const { showDatasetMenu } = $container.dataset;

  new Vue({
    el: $container,
    render: h => h(DatabaseDocumentation, {
      props: {
        showDatasetMenu: showDatasetMenu === "true"
      }
    })
  });
}
